import { Route, Routes } from "react-router-dom";
import "./App.css";
import Footer from "./Components/footer/Footer";
import Home from "./Components/home/Home";
import Navbar from "./Components/navbar/Navbar";
import About from "./Components/about/About";
import Contact from "./Components/contact/Contact";
import NotFound from "./Components/NotFound";
import Product from "./Components/products/Product";
import MultiManagerPortfolio from "./Components/productsPage/multiManagerPortfolio/multiManagerPortfolio";
import OpportunitiesPortfolio from "./Components/productsPage/opportunitiesPortfolio/opportunitiesPortfolio";
import ProudPortfolio from "./Components/productsPage/proudPortfolio/proudPortfolio";
import DisclaimerPage from "./Components/disclaimer/DisclaimerPage";

function App() {
  return (
    <div className="App">
      <Navbar />
      <div style={{ height: "70px" }}></div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/our-product" element={<Product />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/disclaimer" element={<DisclaimerPage />} />
        <Route
          path="/multimanager-portfolio"
          element={<MultiManagerPortfolio />}
        />
        <Route
          path="/opportunities-portfolio"
          element={<OpportunitiesPortfolio />}
        />
        <Route path="/proud-portfolio" element={<ProudPortfolio />} />
        <Route path="/*" element={<NotFound />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
